import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Autocomplete, TextField } from '@totalsoft/rocket-ui';
import { isValid, getErrors } from '@totalsoft/pure-validations-react';
import LabeledCheckbox from 'components/common/inputs/LabeledCheckbox';

const GenericFilterParamComponent = ({
  genericFilterParam,
  genericFilterParamContexts,
  genericFilterTypes,
  onPropertyChanged,
  validation,
  disabled
}) => {
  const { t } = useTranslation();

  const contextsValue = useMemo(
    () =>
      (genericFilterParam.genericFilterParamXContexts || []).map(({ contextId, contextName }) => ({ id: contextId, name: contextName })),
    [genericFilterParam.genericFilterParamXContexts]
  );

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={4}>
        <TextField
          disabled={disabled || genericFilterParam.paramId}
          fullWidth
          value={genericFilterParam?.paramCode || ''}
          onChange={event => onPropertyChanged('paramCode', event)}
          label={t('GenericFilterParam.GenericFilter.ParamCode')}
          error={!isValid(validation.paramCode)}
          helperText={getErrors(validation.paramCode)}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <TextField
          disabled={disabled || genericFilterParam.paramId}
          fullWidth
          value={genericFilterParam?.paramName || ''}
          onChange={event => onPropertyChanged('paramName', event)}
          label={t('GenericFilterParam.GenericFilter.ParamName')}
          error={!isValid(validation.paramName)}
          helperText={getErrors(validation.paramName)}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <Autocomplete
          disabled={disabled || genericFilterParam.paramId}
          fullWidth
          label={t('GenericFilterParam.GenericFilter.ParamType')}
          options={genericFilterTypes}
          value={genericFilterParam?.paramTypeId}
          valueKey='id'
          labelKey='name'
          simpleValue={true}
          onChange={value => onPropertyChanged('paramTypeId', value)}
        />
      </Grid>
      <Grid item xs={12} sm={8}>
        <Autocomplete
          disabled={disabled}
          isMultiSelection
          isClearable
          fullWidth
          label={t('GenericFilterParam.GenericFilter.Context')}
          options={genericFilterParamContexts}
          onChange={event => onPropertyChanged('filterXContextsIds', event)}
          value={contextsValue}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <LabeledCheckbox
          label={t('GenericFilterParam.GenericFilter.Inactive')}
          checked={genericFilterParam?.inactive || false}
          onChange={value => onPropertyChanged('inactive', value)}
          disabled={disabled}
        />
      </Grid>
    </Grid>
  );
};

GenericFilterParamComponent.propTypes = {
  genericFilterParam: PropTypes.object,
  genericFilterParamContexts: PropTypes.array.isRequired,
  genericFilterTypes: PropTypes.array.isRequired,
  onPropertyChanged: PropTypes.func.isRequired,
  validation: PropTypes.object.isRequired,
  disabled: PropTypes.bool
};
export default GenericFilterParamComponent;
